import React, { useCallback } from 'react';
import { CollectionServer, deleteInArray, DropdownAction, errorCatch, FilterToQueryParameters, GET, JSXMap, Model, POST, QueryDetail, QueryOrder, QueryParametersToFilters, updateInArray, useAuth } from 'fennec-ui';
import dayjs from 'dayjs'
import 'dayjs/locale/ru'
import { useSearchParams } from 'react-router-dom';
import EventListItem from '../../../../components/EventListItem';
import { useIsDesktopOrLaptopContext, useIsMobileContext, useLayoutWidthContext } from '../../../../../common/Context';
import PageLayout from '../../../../components/PageLayout';
import YImage from '../../../../../common/YImage';
import confirmKey from '../../../../components/ConfirmKeyModal';
import Icofont from 'react-icofont';
import { Button, Space } from 'antd';
import AdministratoriPostov from '../../../../forms/AdministratoriPostov';

dayjs.locale('ru');
var _ = require('lodash');

// POST - "/api/mastervkpostov/create" 
// GET - "/api/mastervkpostov/delete/{id}"
// GET - "/api/mastervkpostov/list"
// GET - "/api/mastervkpostov/byid/{id}"

export default function PostsCreatorMasters(props) {
    const auth = useAuth();
    let [searchParams, setSearchParams] = useSearchParams();
    const onChangeRequestParameters = (value) => {
        if (value) {
            setSearchParams(value)
        }
    }

    const filters = React.useCallback(() => QueryParametersToFilters(searchParams, [
        {
            label: "Начало мероприятия",
            name: "meropriyatie.nachaloSorevnovaniya",
            type: "date",
            filterType: "range",
            sort: true,
            filter: true,
            sorted: "ASC",
        },
    ]), [searchParams]);
    const ConvertFilterToQueryParameters = useCallback((value) => {
        if (onChangeRequestParameters) {
            onChangeRequestParameters(FilterToQueryParameters(filters(), value.filter, value.sorting, value.page, value.count))
        }
    }, [onChangeRequestParameters])
    const QueryParametersToPage = useCallback(() => {
        if (searchParams)
            return searchParams.get("page") || 1;
    }, [searchParams]);
    const QueryParametersToPageCount = useCallback(() => {
        if (searchParams)
            return searchParams.get("count") || 15;
    }, [searchParams]);

    const FilterFromContextFilter = React.useCallback(() => [
        // QueryParam("w-nu-OrganizatorFederatsiya", 0),
        // If((dance && dance.length > 0), QueryParam("w-in-KategoriiUchastnikovNaMeropriyatiyakhMeropriyatie.TantsevalnayaDistsiplina.VidTantsa.Tanets", dance?.join(","))),
    ], []);

    const [layoutWidth, setLayoutWidth] = useLayoutWidthContext();
    const isMobile = useIsMobileContext();
    const isDesktopOrLaptop = useIsDesktopOrLaptopContext();

    return (
        <PageLayout hideSider={true}>
            <div style={{ backgroundColor: "white", borderRadius: "4px" }}>
                <div style={{ padding: "10px" }}>
                    <CollectionServer
                        auth={auth}
                        name={"MasterVkPostov"}
                        source={`/api/mastervkpostov/list`}
                        contextFilters={FilterFromContextFilter}
                        filters={filters}
                        onChangeRequestParameters={ConvertFilterToQueryParameters}
                        page={QueryParametersToPage}
                        count={QueryParametersToPageCount}
                        size={"small"}

                        customRender={(items, {
                            collection,
                            setCollection,
                            setCollectionItem,
                            removeCollectionItem,
                            collectionActions,
                            modelActions,
                            update
                        }) => (<div>
                            {JSXMap(items, (item, idx) => {
                                return (<EventListItem
                                    key={idx}
                                    event={item?.meropriyatie}
                                    // qr={item.Data}
                                    // tickets={ticket()}

                                    // adminButton={true}
                                    hideBuyButton={true}
                                    hideDetailButton={true}

                                    extButtons={({ path, size, style }) => (
                                        <div>
                                            <Space.Compact>
                                                <Button size='small' className={`btn btn-soft-secondary btn-sm`} style={style} href={`${path(1)}/${item.ID}`}>Перейти в мастер</Button>
                                                <DropdownAction
                                                    // style={{ padding: "0" }}
                                                    button={() => (<div className={`bg bg-grey pointer`} style={{ minWidth: "25px", maxWidth: "25px", display: "flex", height: "100%", justifyContent: "center", alignItems: "center" }}>
                                                        <i className="fa fa-ellipsis-h"></i>
                                                    </div>)}
                                                    items={modelActions(item, idx)?.map((e, idx) => ({
                                                        key: e.key || idx,
                                                        auth: auth,
                                                        mode: "MenuItem",
                                                        object: item,
                                                        collection: collection,
                                                        setCollection: setCollection,
                                                        ...e
                                                    }))} />
                                            </Space.Compact>

                                            {/* <div key="view">
                                                <a
                                                    style={style}
                                                    className={`btn btn-soft-secondary btn-sm`}
                                                    href={`${path(1)}/${item.ID}`}
                                                >
                                                    Перейти в мастер
                                                </a>
                                            </div> */}

                                        </div>
                                    )}
                                    size={"medium"}
                                />)
                            })}
                        </div>)}

                        collectionActions={() => [{
                            auth: auth,
                            action: (values, unlock, close, { collection, setCollection }) => {
                                POST(auth, `/api/mastervkpostov/create`, values,
                                    ({ data }) => {
                                        setCollection(updateInArray(collection, data, true));
                                        close();
                                    }, (err) => errorCatch(err, unlock)
                                );
                            },
                            title: "Создать",
                            modal: {
                                title: "Создание мастера",
                                width: "650px"
                            },
                            // form: ModernUserSelection,
                            form: Model,
                            meta: [
                                {
                                    label: "Мероприятие",
                                    name: "meropriyatie",
                                    type: "object",
                                    mode: "dialog",
                                    modal: { width: "650px" },
                                    relation: {
                                        uiFilter: () => [
                                            {
                                                label: "Дата начала",
                                                name: "nachaloSorevnovaniya",
                                                type: "date",
                                                filterType: "range",
                                                sort: true,
                                                filter: true,

                                                sorted: "ASC",
                                                filtered: [dayjs().subtract(5, "days"), dayjs().add(1, "years")],
                                            },
                                            {   // Тип мероприятия
                                                label: "Тип мероприятия",
                                                name: "tipMeropriyatiya",
                                                filterType: "group",
                                                display: (o) => o.opisanie,
                                                sort: true,
                                                filter: true
                                            },
                                            {   // Уровень мероприятия
                                                label: "Уровень мероприятия",
                                                name: "urovenMeropriyatiya",
                                                filterType: "group",
                                                display: (o) => o.opisanie,
                                                sort: true,
                                                filter: true
                                            },
                                            {   // Место проведения
                                                label: "Место проведения",
                                                name: "mestoProvedeniya",
                                                filterType: "group",
                                                display: (o) => o.name,
                                                sort: true,
                                                filter: true
                                            },
                                        ],
                                        displayString: (item) => {
                                            return dayjs(item.nachaloSorevnovaniya).format("DD.MM.YYYY") + " - " + item.nazvanieMeropriyatiya + ", " + item?.mestoProvedeniya?.name
                                        },
                                        display: (item) => {
                                            return (
                                                <div key={item.ID} style={{ display: "flex", justifyContent: "space-between", alignItems: "center", width: "100%", padding: "2px 5px", marginBottom: "5px" }}>

                                                    <div style={{ width: "32px", height: "32px", overflow: "hidden", borderRadius: "4px" }}>
                                                        <YImage item={item} width={32} hidePreview={true} />
                                                    </div>

                                                    <div style={{ flex: "auto", paddingLeft: "7px" }}>
                                                        <div key="q1" style={{ textOverflow: "initial", whiteSpace: "normal", marginTop: "0px", fontSize: "14px" }}>
                                                            <span style={{ fontWeight: "600" }}>{item.nazvanieMeropriyatiya}</span>
                                                        </div>
                                                        <div key="q3" style={{ textOverflow: "initial", whiteSpace: "normal", marginTop: "0px", fontSize: "12px" }}>
                                                            <span style={{
                                                                marginRight: "5px",
                                                                borderRadius: "5px",

                                                                // backgroundColor: "#f6214b",
                                                                // color: "white",

                                                                backgroundColor: (dayjs().isAfter(item.okonchanieSorevnovaniya)) ? "#eaeaea" : "#f6214b",
                                                                color: (dayjs().isAfter(item.okonchanieSorevnovaniya)) ? "black" : "white",
                                                                fontWeight: (dayjs().isAfter(item.okonchanieSorevnovaniya)) ? "400" : "600",

                                                                fontSize: "12px",


                                                                boxShadow: "rgba(34, 60, 80, 0.3) 0px 3px 1px -2px",
                                                                padding: "2px 4px"
                                                            }}>{dayjs(item.nachaloSorevnovaniya).tz("Europe/Moscow").format('DD.MM.YYYY')}</span>
                                                            <span>{item?.mestoProvedeniya?.name}</span>
                                                        </div>
                                                    </div>
                                                </div>
                                            )
                                        },
                                        reference: { object: "Meropriyatiya", property: "ID", source: "/api/meropriyatiya/list/com" },
                                        type: "many-one",
                                    },
                                    queryFilter: [
                                        QueryDetail("combobox"),
                                        QueryOrder("nachaloSorevnovaniya", "DESC")
                                    ]
                                },
                            ],
                        }]}
                        modelActions={(item) => {
                            return [
                                {
                                    auth: auth,
                                    action: (values, unlock, close, { collection, setCollection }) => {
                                        POST(auth, `/api/mastervkpostov/update`, { ...values, ID: item?.ID },
                                            ({ data }) => {
                                                setCollection(updateInArray(collection, data, true));
                                                close();
                                            }, (err) => errorCatch(err, unlock)
                                        );
                                    },
                                    title: "Изменить",
                                    modal: {
                                        title: "Изменение мастер постов",
                                        width: "650px"
                                    },
                                    form: Model,
                                    meta: [
                                        {
                                            label: "Мероприятие",
                                            name: "meropriyatie",
                                            type: "object",
                                            mode: "dialog",
                                            modal: { width: "650px" },
                                            relation: {
                                                uiFilter: () => [
                                                    {
                                                        label: "Дата начала",
                                                        name: "nachaloSorevnovaniya",
                                                        type: "date",
                                                        filterType: "range",
                                                        sort: true,
                                                        filter: true,

                                                        sorted: "ASC",
                                                        filtered: [dayjs().subtract(5, "days"), dayjs().add(1, "years")],
                                                    },
                                                    {   // Тип мероприятия
                                                        label: "Тип мероприятия",
                                                        name: "tipMeropriyatiya",
                                                        filterType: "group",
                                                        display: (o) => o.opisanie,
                                                        sort: true,
                                                        filter: true
                                                    },
                                                    {   // Уровень мероприятия
                                                        label: "Уровень мероприятия",
                                                        name: "urovenMeropriyatiya",
                                                        filterType: "group",
                                                        display: (o) => o.opisanie,
                                                        sort: true,
                                                        filter: true
                                                    },
                                                    {   // Место проведения
                                                        label: "Место проведения",
                                                        name: "mestoProvedeniya",
                                                        filterType: "group",
                                                        display: (o) => o.name,
                                                        sort: true,
                                                        filter: true
                                                    },
                                                ],
                                                displayString: (item) => {
                                                    return dayjs(item.nachaloSorevnovaniya).format("DD.MM.YYYY") + " - " + item.nazvanieMeropriyatiya + ", " + item?.mestoProvedeniya?.name
                                                },
                                                display: (item) => {
                                                    return (
                                                        <div key={item.ID} style={{ display: "flex", justifyContent: "space-between", alignItems: "center", width: "100%", padding: "2px 5px", marginBottom: "5px" }}>

                                                            <div style={{ width: "32px", height: "32px", overflow: "hidden", borderRadius: "4px" }}>
                                                                <YImage item={item} width={32} hidePreview={true} />
                                                            </div>

                                                            <div style={{ flex: "auto", paddingLeft: "7px" }}>
                                                                <div key="q1" style={{ textOverflow: "initial", whiteSpace: "normal", marginTop: "0px", fontSize: "14px" }}>
                                                                    <span style={{ fontWeight: "600" }}>{item.nazvanieMeropriyatiya}</span>
                                                                </div>
                                                                <div key="q3" style={{ textOverflow: "initial", whiteSpace: "normal", marginTop: "0px", fontSize: "12px" }}>
                                                                    <span style={{
                                                                        marginRight: "5px",
                                                                        borderRadius: "5px",

                                                                        // backgroundColor: "#f6214b",
                                                                        // color: "white",

                                                                        backgroundColor: (dayjs().isAfter(item.okonchanieSorevnovaniya)) ? "#eaeaea" : "#f6214b",
                                                                        color: (dayjs().isAfter(item.okonchanieSorevnovaniya)) ? "black" : "white",
                                                                        fontWeight: (dayjs().isAfter(item.okonchanieSorevnovaniya)) ? "400" : "600",

                                                                        fontSize: "12px",


                                                                        boxShadow: "rgba(34, 60, 80, 0.3) 0px 3px 1px -2px",
                                                                        padding: "2px 4px"
                                                                    }}>{dayjs(item.nachaloSorevnovaniya).tz("Europe/Moscow").format('DD.MM.YYYY')}</span>
                                                                    <span>{item?.mestoProvedeniya?.name}</span>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    )
                                                },
                                                reference: { object: "Meropriyatiya", property: "ID", source: "/api/meropriyatiya/list/com" },
                                                type: "many-one",
                                            },
                                            queryFilter: [
                                                QueryDetail("combobox"),
                                                QueryOrder("nachaloSorevnovaniya", "DESC")
                                            ]
                                        },
                                    ],
                                },
                                {
                                    title: "Администраторы",
                                    // mode: "MenuItem",
                                    auth: auth,
                                    object: item,
                                    form: AdministratoriPostov,
                                    readonly: true,
                                    noAntForm: true,
                                    modal: {
                                        width: "660px"
                                    },
                                    action: (values, unlock, close) => {}
                                },
                                {
                                    auth: auth,
                                    title: <span style={{ color: "red" }}>Удалить</span>,
                                    action: (values, unlock, close, { collection, setCollection }) => {
                                        confirmKey({
                                            pass: '723',
                                            title: <span><Icofont icon="check-circled" style={{ color: "orange" }} /> Удалить мастер</span>,
                                            icon: undefined,
                                            content: <div>
                                                <div>Вы действительно хотите удалить мастер постов?</div>
                                                <div style={{ fontSize: "14px", fontWeight: "bold" }}>{item?.nazvanie} </div>
                                            </div>,
                                            okText: 'Удалить',
                                            cancelText: 'Отмена',
                                            onOk() {
                                                return new Promise((resolve, reject) => {
                                                    GET(auth, '/api/mastervkpostov/delete/' + item.ID,
                                                        ({ data }) => {
                                                            setCollection(deleteInArray(collection, item));
                                                            resolve(data);
                                                        }, (err) => errorCatch(err, reject));
                                                }).catch(() => { });
                                            },
                                            onCancel() {
                                            },
                                        })
                                    }
                                }
                            ]
                        }}
                    />
                </div>
            </div>
        </PageLayout>
    );
}
